import React from 'react';
import Section from './Section';
import Card from './Card';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      title: "Financial Market Briefing Pipeline",
      description: "Automated daily market briefing workflow.",
      highlights: [
        "Aggregates market, stock, and news data and computes trading signals.",
        "Generates daily briefings and delivers them by email.",
        "Stores extracted features in SQLite and runs as containerized scheduled services."
      ],
      techStack: ["Python", "SQLite", "Docker", "Ollama", "Chroma", "Windows Task Scheduler"],
      githubLink: "",
      demoLink: "",
      image: "/images/briefing.png"
    }
  ];

  return (
    <Section
      id="projects"
      title="Projects"
      subtitle="Selected technical work."
      className="projects-section"
    >
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-item"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <Card {...project} />
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Projects;
